import { useMemo } from 'react';
import type { ScreenState } from '@hana/ui';

export interface FinanceAccess {
  /** Quyền tiền: mọi màn của vùng tài chính nằm sau quyền này; không có → trạng thái `noperm`. */
  money: boolean;
  /** Ép trạng thái màn như prop `state` của board (xem thử / chụp ảnh). */
  force: ScreenState | null;
}

const STATES: readonly ScreenState[] = ['ready', 'loading', 'empty', 'error', 'noperm'];

/** Đọc quyền từ chuỗi truy vấn (`?money=view&state=…`) — cùng quy ước với tra giá. TODO(A): quyền thật từ phiên đăng nhập khi luồng A có. */
export function readFinanceAccess(search: string): FinanceAccess {
  const p = new URLSearchParams(search);
  const st = p.get('state') as ScreenState | null;
  return { money: p.get('money') === 'view', force: st && STATES.includes(st) ? st : null };
}

export function useFinanceAccess(search: string = typeof location === 'undefined' ? '' : location.search): FinanceAccess {
  return useMemo(() => readFinanceAccess(search), [search]);
}

